//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'IVDripRate',
  data() {
    return {
      defaultJson: {
        'Desired Duration': '预计时间',
        'Drip rate': '滴速',
        'Drop Factor (set)': '每毫升滴数（预设）',
        'Amount to Infuse': '输液总量'
      },
      form: {
        amount: '',
        time: '',
        drop: ''
      },
      hasScore: false,
      disabled: false,
      dataList1: [
        { value: '0', name: '从不' },
        { value: '10', name: '一周内' },
        { value: '5', name: '曾有' }
      ],
      dataList2: [
        { value: '0', name: '从不' },
        { value: '10', name: '6个月内' },
        { value: '5', name: '超过6个月' }
      ],
      logit: '...'
    }
  },
  created() {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
   isInteger(obj) {
    return obj % 1 === 0
  }
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      console.log(self.form)
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key] && key !== 'drop') {
            flag = false
          } else {
            // if (form[key] === '---') {
            //   flag = false
            // } else {
            form[key] = Number(form[key])
            // }
          }
        }
      }

      if (!flag) {
        self.hasScore = false
        self.logit = '...'
        return '...'
      } else {
        console.log(form)
        let result = 0
        if (form.drop && form.drop != '---') {
          result = this.isInteger((form.amount * form.drop / form.time)) ? (form.amount * form.drop / form.time) : (form.amount * form.drop / form.time).toFixed(5)
        } else {
          result = this.isInteger((60 * form.amount / form.time)) ? (60 * form.amount / form.time) : (60 * form.amount / form.time).toFixed(5)
        }
        self.hasScore = true
        return isNaN(result) ? '---' : String(result)
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/formulas/Anae/IVDripRate.vue